import { Card } from "./Ui";

export function GovernanceGuide() {
  const roles = [
    [
      "Board Chair",
      "Chairs board sessions, sets governance agenda, primary BoG liaison at board level for licence-critical matters.",
    ],
    [
      "Chief Executive Officer",
      "Accountable to the board for overall strategy execution, BoG relationship and capital allocation decisions.",
    ],
    [
      "Chief Financial Officer",
      "Accountable for safeguarding structure, liquidity facility and capital allocation proposals brought to the board.",
    ],
    [
      "Independent NED — Risk & Compliance",
      "Oversight of regulatory risk, BoG engagement strategy, AML/CFT posture and licence-condition compliance.",
    ],
    [
      "Independent NED — Technology & Product",
      "Oversight of platform resilience, technology investment decisions and major build-vs-buy calls.",
    ],
    [
      "Investor Director",
      "Represents shareholder interests in capital allocation, partnership commitments and strategic pivots.",
    ],
    [
      "Company Secretary",
      "Maintains board minutes, escalation log and tracks board decisions through to the S&E dashboard.",
    ],
  ];
  return (
    <Card className="span-2">
      <h2>Board responsibilities and reporting guide</h2>
      <details>
        <summary>Board composition and responsibilities</summary>
        <div className="table-wrap">
          <table className="initiative-table">
            <thead>
              <tr>
                <th>Role</th>
                <th>Responsibility</th>
              </tr>
            </thead>
            <tbody>
              {roles.map(([role, text]) => (
                <tr key={role}>
                  <td>{role}</td>
                  <td>{text}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </details>
      <details>
        <summary>Escalation rules in this application</summary>
        <p>
          A regulatory/BoG approval requirement, material capital commitment,
          contractual exclusivity, or material enterprise risk flags board
          review regardless of RICE. These checks are reviewer inputs, not automatic escalation decisions.
          An authorised reviewer first approves escalation, then explicitly sends
          in-app notifications to eligible governance viewers. Email is not sent.
        </p>
        <p>
          The original design proposed a Category A / adjusted RICE above 150
          threshold and notification deadlines. Those proposals are not
          configured automation and need management confirmation. Urgent
          regulatory matters should be raised directly through the
          organisation’s escalation process.
        </p>
      </details>
      <details>
        <summary>Reporting flow and meeting preparation</summary>
        <ol>
          <li>
            Department leads or deputies submit initiatives and supporting
            information.
          </li>
          <li>
            S&E validates ownership, scoring, dependencies and escalation
            conditions during weekly intake triage.
          </li>
          <li>
            The bi-weekly prioritisation review resolves sequencing and
            constraints with Product, Engineering and Compliance.
          </li>
          <li>
            CEO/COO and function heads review the executive portfolio monthly.
            S&E prepares priorities, board items, regulatory approvals, ageing,
            dependency risks and quarterly capacity assessments.
          </li>
          <li>
            The Board reviews escalated decisions and the quarterly portfolio.
            The Company Secretary or authorised S&E administrator records
            decisions and rationale in the initiative lifecycle.
          </li>
          <li>
            The quarterly reset reviews the backlog, rescoring and closed work
            with the leadership team.
          </li>
        </ol>
        <p>
          This guide describes responsibilities; it does not automatically
          schedule meetings or send email.
        </p>
      </details>
    </Card>
  );
}
